import React from 'react';

export default function BackgroundCircles() {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      {/* Circle 1 */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-white/10 backdrop-blur-sm rounded-full blur-3xl animate-circle-1" />
      
      {/* Circle 2 */}
      <div className="absolute top-1/3 right-1/4 w-72 h-72 bg-white/10 backdrop-blur-sm rounded-full blur-3xl animate-circle-2" />
      
      {/* Circle 3 */}
      <div className="absolute bottom-1/4 left-1/3 w-64 h-64 bg-white/10 backdrop-blur-sm rounded-full blur-3xl animate-circle-3" />
      
      {/* Circle 4 */}
      <div className="absolute top-1/2 right-1/3 w-80 h-80 bg-white/10 backdrop-blur-sm rounded-full blur-3xl animate-circle-4" />
      
      {/* Circle 5 */}
      <div className="absolute bottom-1/3 left-1/2 w-56 h-56 bg-white/10 backdrop-blur-sm rounded-full blur-3xl animate-circle-5" />
    </div>
  );
}